import React, { useEffect, useState } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { __ } from '../../core/utils';
import Select from '../../components/Select';
import DateTimePicker from '../../components/DateTimePicker';
import Input from '../../components/Input';
import Textarea from '../../components/Textarea';
import Button from '../../components/Button';
import { listPossibleLeaveReasons } from '../../redux/actions/table/timesheets';
import styles from '../../styles/forms/timesheets/AddTimesheetEntryTimeOffForm.scss';

const EditTimesheetEntryTimeOffForm = (props) => {
  const { values = {}, handleSubmit, onClose, onSubmit } = props;
  const [possibleLeaveReasons, setPossibleLeaveReasons] = useState([]);

  useEffect(() => {
    listPossibleLeaveReasons().then(({ response }) => {
      setPossibleLeaveReasons(response.data || []);
    });
  }, []);

  return (
    <Form className={styles.wrapper} onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.form}>
        {values?.all_day ? (
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name={values?.is_multi_day ? 'date_range' : 'date_display'}
                component={DateTimePicker}
                label={__('table.columns.task-date-time')}
                footer
                range={values?.is_multi_day}
                disabled
              />
            </div>
          </div>
        ) : (
          <div className={styles.flex}>
            <div className={styles.f2}>
              <Field
                name='date'
                component={DateTimePicker}
                label={__('table.columns.timesheet-date')}
                footer
                disabled
              />
            </div>
            <div className={styles.f2}>
              <Field
                name='hours'
                component={Input}
                label={__('table.columns.timesheet-hours')}
                numeric
                maxLength={4}
                hint={__('timesheets.hint.in-hours')}
              />
            </div>
            <div className={styles.f2}>
              <Field
                name='minutes'
                component={Input}
                label={__('table.columns.timesheet-minutes')}
                numeric
                maxLength={2}
                hint={__('timesheets.hint.in-minutes')}
              />
            </div>
          </div>
        )}

        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='leave_reason_id'
              component={Select}
              searchable
              options={_.map(possibleLeaveReasons, (leaveReason) => ({
                value: leaveReason.id,
                label: leaveReason.name,
              }))}
              label={__('table.columns.timesheet-reason')}
              placeholder={__('add-timesheet-form.select-reason')}
            />
          </div>
        </div>

        <Field
          name='description'
          component={Textarea}
          label={__('add-timesheet-form.description')}
          maxLength={200}
          rows={1}
          maxRows={5}
          placeholder={__('add-timesheet-form.add-description')}
        />

        <div className={styles.footer}>
          <Button
            lightGray
            medium
            middleText={__('button.cancel')}
            onClick={onClose}
          />
          <Button
            lightBlue
            medium
            middleText={__('button.save')}
            submit
          />
        </div>
      </div>
    </Form>
  );
};

export default reduxForm({
  form: 'timesheet_entries.edit_time_off',
  enableReinitialize: true,
})(
  connect((state) => ({
    values: getFormValues('timesheet_entries.edit_time_off')(state),
  }))(EditTimesheetEntryTimeOffForm)
);
